import { useEffect, useRef, useState } from "react";

/**
 * Count-up animation for numeric stats.
 * Passes through non-numeric values as-is.
 */
export default function AnimatedCounter({
  value,
  duration = 900,
  className = "",
  testid,
}) {
  const [display, setDisplay] = useState(
    typeof value === "number" ? 0 : value
  );
  const rafRef = useRef(null);
  const startRef = useRef(null);
  const fromRef = useRef(0);

  useEffect(() => {
    if (typeof value !== "number") {
      setDisplay(value);
      return undefined;
    }
    const from = fromRef.current;
    const to = value;
    if (from === to) return undefined;

    const animate = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const elapsed = ts - startRef.current;
      const t = Math.min(1, elapsed / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = Math.round(from + (to - from) * eased);
      setDisplay(current);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        fromRef.current = to;
        startRef.current = null;
      }
    };
    rafRef.current = requestAnimationFrame(animate);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      startRef.current = null;
    };
  }, [value, duration]);

  return (
    <span className={className} data-testid={testid}>
      {display}
    </span>
  );
}
